import styled from "styled-components";



const HelpDescriptionStyled = {

    Container: styled.div`
    `


}

export default HelpDescriptionStyled;